import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-camera",
  templateUrl: "./med-icon-camera.component.html",
})
export class MedIconCameraComponent extends SvgMixinComponent {}
